<template>
  <v-container id="logs-copy-dialog">
    <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
    //-->

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="1200px"
      :fullscreen="$vuetify.breakpoint.mobile"
      no-click-animation
      :overlay-opacity="0.7"
      persistent
    >
      <v-card
        max-height="900px"
        class="backdrop dialog-card"
        id="swal_log_copy_dialog"
      >
        <v-overlay absolute :value="overlay_loading">
          <v-progress-circular
            indeterminate
            :size="80"
            :width="7"
            color="secondary"
          ></v-progress-circular>
        </v-overlay>
        <v-card-title class="backdrop lighten-1 dialog-title">
          <span class="text-h5">Copy Log(s)</span>
        </v-card-title>
        <v-card-text class="backdrop pa-0 white--text">
          <v-container class>
            <v-form v-model="validForm" ref="form">
              <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div>
                      To copy the selected {{ logEntryIDs.length }} log(s), you
                      must choose a log type for the new log(s).
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="divisions_list"
                      v-model="copy_form.logType"
                      label="Log Type"
                      placeholder="Select a log type"
                      maxlength="60"
                      color="secondary"
                      filled
                      outlined
                      :rules="[field_rules.required]"
                    >
                    </v-select>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
        </v-card-text>

        <!--Dialog Buttons-->
        <v-card-actions class="backdrop lighten-1 border-card">
          <v-spacer></v-spacer>

          <v-btn color="secondary" class="black--text" @click="priorToClose">
            Close
          </v-btn>
          <v-btn
            color="secondary"
            class="black--text"
            :disabled="!validForm"
            @click="priorToCopyLogs()"
          >
            Copy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../../scss/site.scss";

.dialog-card {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}

.dialog-title {
  margin-bottom: 2px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
}

.custom-divider {
  height: 2px;
  background-color: black;
}

.border-card {
  margin: 2px;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../../mixins/bus_common";
export default {
  name: "logs-copy-dialog",
  mixins: [bus_common],
  props: {
    logEntryIDs: Array,
  },
  components: {},
  data() {
    return {
      dialog: true,
      overlay_loading: false,
      validForm: false,
      field_rules: {
        required: (value) => !!value || "This field is required",
        requiredCombo: (v) => v.length >= 1 || "At least one email is required",
        min: (v) => v.length >= 8 || "Min 8 characters",
        max25: (v) => v.length <= 60 || "Max 60 characters",
      },
      swal_target: "swal_log_copy_dialog",
      copy_form: {
        logType: "",
      },
    };
  },
  methods: {
    priorToClose() {
      let callback = () => {
        this.closeDialog();
      };
      this.swall_diag(
        "Close?",
        "Are you sure you would like to close this dialog? Any unsaved changes will be lost.",
        "question",
        callback,
        "Yes",
        "No",
        null,
        this.swal_target
      );
    },

    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$emit("closeDialog");
      }, 300);
    },

    priorToCopyLogs() {
      let callback = () => {
        this.copyLogs();
      };
      this.swall_diag(
        "Copy Log(s)?",
        `Are you sure you would like to copy these ${this.logEntryIDs.length} log(s) ?`,
        "question",
        callback,
        "Yes",
        "No",
        null,
        this.swal_target
      );
    },

    async copyLogs() {
      let callback = () => {
        this.closeDialog();
      };

      var form = {
        token: this.$store.state.user.token,
        logEntryIDs: this.logEntryIDs,
        logType: this.copy_form.logType,
      };

      this.overlay_loading = true;
      await this.$axios
        .post("/api/logs/CopyLogs", form)
        .then((response) => {
          this.swall_it(
            "Log(s) Copied!",
            "The log(s) were successfully copied.",
            "success",
            callback,
            null,
            this.swal_target
          );
          this.overlay_loading = false;
        })
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
          this.overlay_loading = false;
        });
    },
    async init() {},
  },
  watch: {},

  computed: {
    divisions_list() {
      if (this.$store.state.logDivisions.length > 0) {
        return this.$store.state.logDivisions.map((d) => d.displayName);
      } else {
        return null;
      }
    },
  },

  mounted() {
    this.init();
  },
};
</script>
